import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { mergeWithGlobal } from './_helpers';
import ConsoleForm from './ConsoleForm';

function Console(_ref) {
  var {
    host,
    isAdmin,
    isLoggedIn,
    handleNotLoggedIn,
    endpoint,
    initialParameters,
    screenWidth,
    scenarioId,
    customFunction,
    setCustomFunction
  } = _ref;
  var [defaultParameters, setDefaultParameters] = useState(mergeWithGlobal(initialParameters));
  useEffect(() => {
    setDefaultParameters(mergeWithGlobal(initialParameters));
  }, [initialParameters]);

  var initialValues = _.reduce(defaultParameters, function (result, parameter) {
    var {
      name
    } = parameter;
    var value = _.isNil(parameter.default) ? '' : parameter.default;
    result[name] = {
      checked: parameter.required,
      value
    };
    return result;
  }, {});

  return /*#__PURE__*/React.createElement(ConsoleForm, {
    host: host,
    isAdmin: isAdmin,
    isLoggedIn: isLoggedIn,
    handleNotLoggedIn: handleNotLoggedIn,
    endpoint: endpoint,
    parameters: defaultParameters,
    initialValues: initialValues,
    screenWidth: screenWidth,
    initialScenarioId: scenarioId,
    customFunction: customFunction,
    setCustomFunction: setCustomFunction
  });
}

Console.propTypes = {
  host: PropTypes.string,
  isAdmin: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  screenWidth: PropTypes.number,
  scenarioId: PropTypes.number,
  customFunction: PropTypes.string
};
Console.defaultProps = {
  host: 'web',
  isAdmin: false,
  isLoggedIn: false,
  scenarioId: null,
  customFunction: 'QUERYA'
};
export default Console;